import {
	createStore,
	compose as origCompose,
	applyMiddleware,
	combineReducers
} from 'redux';
import thunk from 'redux-thunk';

import app from './reducers/app.js';
import newInspections from './reducers/new-inspections.js';
import localInspections from './reducers/local-inspections.js';
import completedInspections from './reducers/completed-inspections.js';
import inspection from './reducers/inspection.js';
import validation from './reducers/validation.js';
import { inspectionLoaderMiddleware } from './inspection-loader-middleware.js';
// Sets up a Chrome extension for time travel debugging.
// See https://github.com/zalmoxisus/redux-devtools-extension for more information.
const compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || origCompose;

export const store = createStore(
	combineReducers({ app, newInspections, localInspections, completedInspections, inspection, validation }),
	compose(applyMiddleware(thunk, inspectionLoaderMiddleware))
);
